import { useQuery, useMutation } from '@apollo/client';
import { useParams } from 'react-router';

import {
  CompanyConfigurationQuery,
  CompanyConfigurationQueryVariables,
  UpdateCompanyConfigurationMutation,
  UpdateCompanyConfigurationMutationVariables,
  UpdateCompanySettingMutation,
  UpdateCompanySettingMutationVariables,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CompanyConfigurationViewProps, CompanyConfigurationView } from '../components/company_configuration';
import {
  companyConfigurationQuery,
  updateCompanyConfigurationMutation,
  updateCompanySettingMutation,
} from '../graphql';

class LoadingContainer extends Loader<
  CompanyConfigurationQuery,
  CompanyConfigurationViewProps,
  CompanyConfigurationQueryVariables
> {}

export const CompanyConfigurationContainer = () => {
  const { company_id } = useParams() as { company_id: string };
  const result = useQuery<CompanyConfigurationQuery, CompanyConfigurationQueryVariables>(companyConfigurationQuery, {
    variables: {
      company_id,
    },
  });
  const [updateCompanyConfiguration] = useMutation<
    UpdateCompanyConfigurationMutation,
    UpdateCompanyConfigurationMutationVariables
  >(updateCompanyConfigurationMutation);
  const [updateCompanySetting] = useMutation<UpdateCompanySettingMutation, UpdateCompanySettingMutationVariables>(
    updateCompanySettingMutation,
  );

  return (
    <LoadingContainer
      result={result}
      mapData={({ data }) => ({
        data: { company: data.company ?? null, __typename: 'Query' },
        updateConfiguration: async (input: UpdateCompanyConfigurationMutationVariables['input']) => {
          await updateCompanyConfiguration({
            refetchQueries: [
              {
                query: companyConfigurationQuery,
                variables: { company_id },
              },
            ],
            variables: {
              input,
            },
          });
        },
        updateSetting: async (input: UpdateCompanySettingMutationVariables['input']) => {
          await updateCompanySetting({
            refetchQueries: [
              {
                query: companyConfigurationQuery,
                variables: { company_id },
              },
            ],
            variables: {
              input,
            },
          });
        },
      })}>
      {({ data, updateConfiguration, updateSetting }) => (
        <CompanyConfigurationView data={data} updateConfiguration={updateConfiguration} updateSetting={updateSetting} />
      )}
    </LoadingContainer>
  );
};
